export const PENDING_BUOY_TAG_ID_STORAGE_KEY = 'onbuoyPendingTagId';
export const BUOY_TAG_ALREADY_CLAIMED_MESSAGE = 'This buoy tag has already been claimed.';

export const isValidBuoyTagId = tagId => {
  if (typeof tagId !== 'string' || !/^\d{3}$/.test(tagId)) {
    return false;
  }

  const numericTagId = Number(tagId);
  return numericTagId >= 1 && numericTagId <= 250;
};

const getSessionStorage = () => {
  try {
    return typeof window !== 'undefined' ? window.sessionStorage : null;
  } catch (e) {
    return null;
  }
};

export const getPendingBuoyTagId = () => {
  const storage = getSessionStorage();
  const tagId = storage ? storage.getItem(PENDING_BUOY_TAG_ID_STORAGE_KEY) : null;

  return isValidBuoyTagId(tagId) ? tagId : null;
};

export const setPendingBuoyTagId = tagId => {
  const storage = getSessionStorage();
  if (!storage) {
    return false;
  }

  if (!isValidBuoyTagId(tagId)) {
    storage.removeItem(PENDING_BUOY_TAG_ID_STORAGE_KEY);
    return false;
  }

  storage.setItem(PENDING_BUOY_TAG_ID_STORAGE_KEY, tagId);
  return true;
};

export const clearPendingBuoyTagId = () => {
  const storage = getSessionStorage();
  if (storage) {
    storage.removeItem(PENDING_BUOY_TAG_ID_STORAGE_KEY);
  }
};
